(function () {
  'use strict';

  var config = document.currentScript;
  if (!config || !config.dataset.src) return;

  var source = config.dataset.src;
  var retryLimit = 2;
  var loadTimeout = 10000;

  function containsPlayer(root) {
    return Boolean(
      (root.matches && root.matches('lite-youtube')) ||
        (root.querySelector && root.querySelector('lite-youtube')),
    );
  }

  function loadPlayer(attempt) {
    if (customElements.get('lite-youtube')) return Promise.resolve();
    if (window.liteYoutubeLoaderPromise) return window.liteYoutubeLoaderPromise;

    var script = document.createElement('script');
    var scriptUrl = new URL(source, document.baseURI);
    if (attempt) scriptUrl.searchParams.set('lite_youtube_retry', String(attempt));
    script.type = 'module';
    script.src = scriptUrl.href;
    script.dataset.liteYoutubeLoader = 'true';

    var request = new Promise(function (resolve, reject) {
      var timer;
      function cleanup() {
        window.clearTimeout(timer);
        script.removeEventListener('load', onLoad);
        script.removeEventListener('error', onError);
      }
      function onLoad() {
        cleanup();
        resolve();
      }
      function onError() {
        cleanup();
        reject(new Error('Failed to load ' + script.src));
      }

      script.addEventListener('load', onLoad);
      script.addEventListener('error', onError);
      timer = window.setTimeout(function () {
        cleanup();
        reject(new Error('Timed out loading ' + script.src));
      }, loadTimeout);
    }).then(function () {
      if (!customElements.get('lite-youtube')) {
        throw new Error('lite-youtube.js loaded without defining lite-youtube');
      }
    });

    var promise = request.catch(function (error) {
      script.remove();
      if (window.liteYoutubeScript === script) window.liteYoutubeScript = null;
      if (attempt >= retryLimit) {
        if (window.liteYoutubeLoaderPromise === promise) window.liteYoutubeLoaderPromise = null;
        throw error;
      }

      return new Promise(function (resolve) {
        window.setTimeout(resolve, 250 * (attempt + 1));
      }).then(function () {
        if (window.liteYoutubeLoaderPromise === promise) window.liteYoutubeLoaderPromise = null;
        return loadPlayer(attempt + 1);
      });
    });

    window.liteYoutubeScript = script;
    window.liteYoutubeLoaderPromise = promise;
    document.head.appendChild(script);
    return promise;
  }

  function initialize(root) {
    if (!containsPlayer(root) || customElements.get('lite-youtube')) return Promise.resolve();
    return loadPlayer(0);
  }

  function initializeSafely(root) {
    initialize(root).catch(function (error) {
      console.error(error);
    });
  }

  initializeSafely(document);
  new MutationObserver(function (records) {
    records.forEach(function (record) {
      record.addedNodes.forEach(function (node) {
        if (node.nodeType === Node.ELEMENT_NODE && containsPlayer(node)) {
          initializeSafely(node);
        }
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
